<template>
    <div class="tab-summary">
      <v-container id="realTimeData" ref="realTimeData">
        <v-sheet>
            <v-row>
              <v-col :cols="12" :md="4">
                <v-card-title>Current Conditions</v-card-title>
                <v-card-subtitle>As of {{ this.station.TmStamp.date.substring(0, 19) }}</v-card-subtitle>
                <c-data-list v-model="currentRecord" />
                <!--<v-btn text block @click="$toast.success('Add a data dialog here.')">
                <v-icon class="tw-mr-4">mdi-plus-circle-outline</v-icon>
                  More Realtime Data
                </v-btn>-->
              </v-col>
              <v-col :cols="12" :md="8">
                <the-tab-summary-temperature :records="records" />
              </v-col>
            </v-row>
        </v-sheet>
      </v-container>
      <v-container class="extended right tw-flex tw-relative tw-min-h-full">
        <div class="main-content tw-w-full tw-min-w-0">
          <v-sheet id="summary">
            <v-container>
              <the-tab-recent-summary-grid />
            </v-container>
          </v-sheet>
          <v-sheet id="weather">
            <v-card-title>
              Weather Forecast
              <v-spacer />
            </v-card-title>
            <v-container>
              <v-chip-group mandatory active-class="tw-bg-primary tw-text-white">
                <v-chip>Daily</v-chip>
<!--                <v-chip>Hourly</v-chip>-->
              </v-chip-group>
              <the-station-detail-summary-weather :station="station"  />
            </v-container>
          </v-sheet>
<!--          <v-sheet id="tools" class="tw-mt-20">-->
<!--           <v-card-title>Tools</v-card-title>-->
<!--            <v-container>-->
<!--              <the-tools-nav-list />-->
<!--            </v-container>-->
<!--          </v-sheet>-->
          <v-sheet id="siteInformation" class="tw-mt-20">
            <v-card-title>
              Site Information
              <v-spacer />
            </v-card-title>
            <c-data-list :value="_.pick(station,['SiteID', 'Site_Name', 'Site', 'site_alias', 'latitude', 'altitude', 'longitude', 'landscape', 'soil_parent', 'soil_texture', 'vegetation'])" />
          </v-sheet>
          <v-sheet id="instruments" class="tw-mt-20">
            <v-card-title>
              Instruments
              <v-spacer />
            </v-card-title>
            <v-container>
              <v-skeleton-loader v-if="_.isEmpty(instruments)" type="article" />
              <v-row v-else no-gutters>
                <v-col cols="12" md="6" v-for="(instrument, index) in _.uniqBy(instruments, 'Description')" :key="index">
                  <v-list-item>
                    <v-list-item-group>
                      <v-list-item-title>{{ instrument.Description }}</v-list-item-title>
                      <v-list-item-subtitle>{{ instrument.LongDescription }}</v-list-item-subtitle>
                    </v-list-item-group>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>
          <v-sheet id="siteImages" class="tw-mt-20">
            <v-card-title>Site Images</v-card-title>
            <v-container v-if="station.Site_Name">
              <v-row>
                <v-col :cols="12" :sm="6" :md="4" v-for="n in siteImages[station.Site_Name]" :key="n">
                  <enlargeable-image :src="require(`@/assets/images/sites/${station.Site_Name}/${n}.jpg`)"
                   :src_large="require(`@/assets/images/sites/${station.Site_Name}/${n}.jpg`)">
                    <v-img :src="require(`@/assets/images/sites/${station.Site_Name}/${n}.jpg`)" aspect-ratio="1.6" class="tw-rounded-lg tw-bg-gray-100" />
                  </enlargeable-image>
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>
        </div>
        <table-of-content :offset="offset" :toc="toc" class="tw-bg-transparent tw-sticky tw-mt-16" />
        <v-fade-transition>
          <v-btn v-if="!show.navigation"
                 fab fixed color="primary"
                 class="tw-bottom-0 tw-right-0 tw-z-10 tw-m-6"
                 @click="show.navigation = !show.navigation"
          >
            <v-icon>
              mdi-list
            </v-icon>
          </v-btn>
        </v-fade-transition>
      </v-container>
    </div>
</template>

<script>
import TheStationDetailSummaryWeather from '@/components/pages/station/TheStationDetailSummaryWeather'
import TableOfContent from '@/components/common/TableOfContent'
import siteImages from '@/assets/data/siteImages.json'
// import TheToolsNavList from '@/components/pages/TheToolsNavList'
import TheTabSummaryTemperature from '@/components/pages/station/TheTabSummaryTemperature'
import TheTabRecentSummaryGrid from '@/components/pages/station/TheTabRecentSummaryGrid'
import EnlargeableImage from '@diracleo/vue-enlargeable-image'
export default {
  name: 'TheTabSummary',
  props: {
    records: {
      type: Array
    },
    station: {
      type: Object
    }
  },
  components: {
    TheTabRecentSummaryGrid,
    TheTabSummaryTemperature,
    // TheToolsNavList,
    TheStationDetailSummaryWeather,
    TableOfContent,
    EnlargeableImage
  },
  async created () {
    this.instruments = await this.$api.station.get('', {
      id: this.$route.params.id,
      instruments: true
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.offset = this.$refs.realTimeData.clientHeight
      console.log(this.offset)
    })
  },
  data () {
    return {
      offset: 0,
      siteImages,
      instruments: [],
      show: {
        navigation: true
      },
      toc: [
        {
          id: 'realTimeData',
          text: 'Current Conditions'
        },
        {
          id: 'summary',
          text: 'Summary'
        },
        {
          id: 'weather',
          text: 'Weather Forecast'
        },
        // {
        //  id: 'tools',
        //  text: 'Tools'
        // },
        {
          id: 'siteInformation',
          text: 'Site Information'
        },
        {
          id: 'instruments',
          text: 'Instruments'
        },
        {
          id: 'siteImages',
          text: 'Site Images'
        }
      ]
    }
  },
  computed: {
    currentRecord () {
      if (this._.isEmpty(this.records)) return false
      const current = this.station
      return [
        {
          label: 'Air Temperature',
          value: this._.round((current.AirTC_Avg * 1.8) + 32) + ' °F'
        },
        {
          label: 'Humidity',
          value: this._.round(current.RH, 1) + ' %'
        },
        {
          label: 'Precipitation',
          value: this._.round(current.Rain_mm_Tot, 1) + ' mm'
        },
        {
          label: 'Wind Direction',
          value: this._.round(current.WindDir_Avg) + ' Deg'
        },
        {
          label: 'Max Wind Speed',
          value: this._.round(current.WS_ms_Max * 2.237) + ' MPH'
        },
        {
          label: 'Average Wind Speed',
          value: this._.round(current.WS_ms_Avg * 2.237) + ' MPH'
        },
        {
          label: 'Soil Temperature(4 in.)',
          value: this._.round((current.TSoil_4in_Avg * 1.8) + 32) + ' °F'
        }
      ]
    },
    averageRecord () {
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.enlargeable-image::v-deep{
    .slot{
      height: 100%;
      width: 100%;
    }
  }
</style>
